<template>
  <div>
      <Header title="教学评价" type="0" route="/evaluate"></Header>
    <NOdata title="暂无教学评价~" v-if="evaluateList.length == 0?isShow3:''"></NOdata>
      <div class="grey-contain" v-for="(item,index) in evaluateList" :key="index">
        <div style="width:calc(100% - 80px);">
          <p class="contain-txt">{{item.teacherName}}</p>
          <span class="contain-txt1">教工号：{{item.teacherNumber}}</span>
          <div class="contain-txt1" v-if="item.institute ? isShow1 : ''">所属学院：{{item.institute}}</div>
          <div class="contain-txt1" v-if="item.className ? isShow1 : ''">上课班级：{{item.className}}</div>
          <div class="contain-txt1" v-if="schoolCode == '14360' && item.courseName !='' && item.className == ''">课程：{{item.courseName}}</div>
        </div>
        <button @click="item.isSubmitCode == 0 ? goEvaluate(item) : '' " v-text="item.isSubmitCode == 0 ? '评价' : ''" v-if="isShow"></button>
        <div class="r_box" @click="item.isSubmitCode == 1 ? goCheck(item) : ''" v-else>
            <span class="number">{{item.overallScore}}</span>
            <span class="grade">总评分</span>
        </div>
      </div>

  </div>
</template>

<script>
import { Dialog } from "vant";
import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        evaluateList:[],
        isShow:true,
        isShow1:true,
        isShow3:true,
        schoolCode: sessionStorage.getItem("schoolCode"),
        alertType:this.$route.query.alertType
      }
    },
    methods:{
      goCheck(e){
        this.$router.push({
          path:'/gradeDetails',
          query:{
            'batchId':e.batchId,
            'evaluationCategoriesId':e.evaluationCategoriesId,
            'courseId':e.courseId,
            'teacherId':e.teacherId,
            'noticeId':e.noticeId,
            'schoolClassificationId':e.schoolClassificationId,
            'teacherName':e.teacherName,
            'teacherNumber':e.teacherNumber

          }
        })
      },
      goEvaluate(e){
        if(e.pjfs=="1"){
            this.$router.push({
                path:'/evaluate3fs',
                query:{
                    'batchId':this.$route.query.batchId,
                    'pj05id':this.$route.query.pj05id,
                    'evaluationCategoriesId':e.evaluationCategoriesId,
                    'courseId':e.courseId,
                    'teacherId':e.teacherId,
                    'noticeId':e.noticeId,
                    'schoolClassificationId':e.schoolClassificationId
                }
            })
        }
        else{
            this.$router.push({
                path:'/evaluate3',
                query:{
                    'batchId':this.$route.query.batchId,
                    'pj05id':this.$route.query.pj05id,
                    'evaluationCategoriesId':e.evaluationCategoriesId,
                    'courseId':e.courseId,
                    'teacherId':e.teacherId,
                    'noticeId':e.noticeId,
                    'schoolClassificationId':e.schoolClassificationId
                }
            })
        }
      },
      async getList(){
        const params = {
          batchId: this.$route.query.batchId,
          pj05id: this.$route.query.pj05id,
        }
        const res = await Api.teachTeachingEvaluationList(params)
        if(res.errorCode == 'fail'){
          this.$toast.fail(res.errorMessage)
        }else{
          this.evaluateList = res.data
        }
      }
    },
    created(){
      this.getList()
      if (this.schoolCode == '14360' && this.alertType){
        Dialog.alert({message:"请严格按照相关文件的评优比例进行评价，评价结果提交后原则上不予修改！"});
      }
    },

  }
</script>


<style lang="less" scoped>
  .grey-contain button{background-color: @attendance-background-color-1;padding: 11px 19px;border-radius: 3px;color: @attendance-color-3;min-height: 40px}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .r_box{
        width: 24%;
        height: 42px;
        float: right;
        background: url(../../../assets/images/bg_icon.png) center center no-repeat;
        background-size: 100%;
        /* margin: 20px 20px 0 0; */
        text-align: center;
    }
    .contain-txt{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
    .r_box span{
      display: block
    }
    .r_box .number{
        color: @attendance-color-3;
        font-size: 18px;
        margin-top: 3px
    }
    .r_box .grade{
        color: @attendance-color-3;
        font-size: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/teacher/Evaluate/evaluate2.vue